import {
  afterNextRender,
  afterRender,
  AfterViewInit,
  Component, ElementRef,
  HostListener,
  Inject,
  OnInit, PLATFORM_ID,
  ViewChild, ViewContainerRef
} from '@angular/core';
import {CommonModule, DOCUMENT, isPlatformBrowser} from '@angular/common';
import {AttachmentFromIdPipe} from "../../../pipes/attachmentFromId/attachment-from-id.pipe";
import {BreacrumbsComponent} from "../../elements/breacrumbs/breacrumbs.component";
import {MediaAttachmentComponent} from "../../elements/media-attachment/media-attachment.component";
import {PageNavigationComponent} from "../../elements/page-navigation/page-navigation.component";
import {SwiperModule} from "swiper/angular";
import {PageExtended} from "../../../models/Page/PageExtended";
import {SynapiItem} from "../../../models/Synapi/SynapiItem";
import {WordpressService} from "../../../services/wordpress.service";
import {ActivatedRoute, EventType, Router} from "@angular/router";
import {SEOService} from "../../../services/seo.service";
import {SynapiService} from "../../../services/synapi.service";
import {SynapiPredicate} from "../../../models/Synapi/SynapiPredicate";
import {SynapiItemLabelComponent} from "../../elements/synapi-item-label/synapi-item-label.component";
import {SynapiCriteriaTreeItem} from "../../../models/Synapi/SynapiCriteriaTreeItem";
import {SynapiItemComponent} from "../../elements/synapi-item/synapi-item.component";
import {SynapiListItemsComponent} from "../../elements/synapi-list-items/synapi-list-items.component";
import {SynapiListItems} from "../../../models/Synapi/SynapiListItems";
import {find} from "rxjs";
import {SynapiItemReviewsComponent} from "../../elements/synapi-item-reviews/synapi-item-reviews.component";
import {SynapiMapComponent} from "../../elements/synapi-map/synapi-map.component";
import {Nl2brPipe} from "../../../pipes/nl2br.pipe";
import {NgxSmartModalService} from "ngx-smart-modal";
import {SynapiItemModalSncfComponent} from "../../elements/synapi-item-modal-sncf/synapi-item-modal-sncf.component";
import {SynapiItemGalleryComponent} from "../../elements/synapi-item-gallery/synapi-item-gallery.component";
import {SynapiBookmarkToggleComponent} from "../../elements/synapi-bookmark-toggle/synapi-bookmark-toggle.component";
import {ExtractDomainPipe} from "../../../pipes/extract-domain.pipe";
import {PhoneFormatPipe} from "../../../pipes/phone-format.pipe";
import {ThemeService} from "../../../services/theme.service";
import {SynapiItemTypes} from "../../../models/Synapi/enums/SynapiItemTypes";
import {
  SynapiItemModalFairguestComponent
} from "../../elements/synapi-item-modal-fairguest/synapi-item-modal-fairguest.component";
import {RestoreScrollPositionDirective} from "../../../directives/restore-scroll-position.directive";
import {StripTagsPipe} from "../../../pipes/striptags.pipe";
import {LanguageService} from "../../../services/language.service";
import {FindPipe} from "../../../pipes/find.pipe";
import {AnalyticsService} from "../../../services/analytics.service";
import {RedirectionService} from "../../../services/redirection.service";
import {DynamicFontSizePipe} from "../../../pipes/dynamicFontSize.pipe";

@Component({
  selector: 'fiche',
  standalone: true,
  imports: [CommonModule, AttachmentFromIdPipe, BreacrumbsComponent, MediaAttachmentComponent, PageNavigationComponent, SwiperModule, SynapiItemLabelComponent, SynapiItemComponent, SynapiListItemsComponent, SynapiItemReviewsComponent, SynapiMapComponent, Nl2brPipe, SynapiBookmarkToggleComponent, ExtractDomainPipe, PhoneFormatPipe, RestoreScrollPositionDirective, StripTagsPipe, FindPipe, DynamicFontSizePipe],
  templateUrl: './fiche.component.html',
  styleUrl: './fiche.component.scss'
})
export class FicheComponent implements OnInit, AfterViewInit{
  fiche?: SynapiItem;
  default?: SynapiItem;
  pro?: SynapiItem;
  isPro = false;
  modesPaiement : SynapiCriteriaTreeItem[] = [];
  activites : SynapiCriteriaTreeItem[] = [];
  services : SynapiCriteriaTreeItem[] = [];
  themes : SynapiCriteriaTreeItem[] = [];
  surPlace : {handicap : SynapiCriteriaTreeItem[],parking : SynapiCriteriaTreeItem[], animals : SynapiCriteriaTreeItem[]};
  equipements : SynapiCriteriaTreeItem[] = [];
  classements : SynapiCriteriaTreeItem[] = [];
  restaurants : SynapiCriteriaTreeItem[] = [];
  labels : SynapiCriteriaTreeItem[] = [];
  languesParlees : SynapiCriteriaTreeItem[] = [];
  ficheLiees : SynapiCriteriaTreeItem[] = [];
  navigation : { index: number, title:string }[] = [];
  hasTrainStationNearly : boolean;
  schemaType = 'TouristAttraction';

  @ViewChild("ficheLiees") ficheLieesRef: SynapiListItemsComponent;
  @ViewChild("about") aboutRef: ElementRef;

  scrollPosition : [number,number] = [0,0];
  constructor(
    public synapi : SynapiService,
    public route: ActivatedRoute,
    public seo : SEOService,
    public langService : LanguageService,
    @Inject(DOCUMENT) private doc: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    public modalService : NgxSmartModalService,
    public wordpressService : WordpressService,
    public themeService : ThemeService,
    private analyticsService: AnalyticsService,
    private redirectService: RedirectionService,
    private vcr: ViewContainerRef,
    private router: Router
  ) {
    this.ficheLieesRef = new SynapiListItemsComponent(synapi,themeService,platformId);
    this.scrollPosition = [0,0];

    this.router.events.subscribe(e => {
      if (e.type == EventType.Scroll && e.position) {
        this.scrollPosition = e.position;
      }
    });
  }
  ngOnInit() {
    this.route.paramMap.subscribe((params)=>{
      const slug = params.get("slug");
      this.themeService.setCurrentTemplate('page');
      if(slug){
        const regex = /([^\/]+)-(\d+)$/;
        const params = slug.match(regex);
        if(params){
          const externalId = params?.at(2);
          const slug = params?.at(1);
          if(externalId){
            const predicate = new SynapiPredicate();
            predicate.id = externalId;
            this.synapi.getItem(predicate).then((item)=>{
              if(!item?.Id && item?.Slug != slug){
                this.redirectService.setNotFound("Fiche non trouvée");
              }
              this.default = Object.assign(new SynapiItem(), item);
              this.pro = this.default.Aspects?.find((aspect)=>aspect.Name === "TOURISME_AFFAIRES");
              this.isPro = false;
              this.initFiche(this.default);
            }).catch(()=>{
              this.redirectService.setNotFound("Fiche non trouvée");
            });
          }
        }
      }
    });
  }

  ngAfterViewInit() {
    if(isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.initFicheLiees();
      }, 2000);
    }
  }

  initFiche(fiche: SynapiItem|null){
    try{
      if(fiche?.Id){
        this.fiche = fiche;
        this.themeService.setLanguageList('fiche',this.fiche.ExternalId, this.fiche.Slug).then(()=>{
          if(this.fiche?.Slug)
          this.seo.initHrefLangs(this.themeService.languages??[],this.fiche.Slug);
        });
        this.analyticsService.trackPageView(this.router.url, this.fiche.Title);
        this.initMetas();
        this.initNavigation();
        this.initCriterias();
        this.initFicheLiees();
        this.initSchemaType();
        if(isPlatformBrowser(this.platformId)) {
          setTimeout(() => {
            window.scrollTo(0, this.scrollPosition[1])
          }, 500);
        }
      }
    }catch (e) {
      this.redirectService.setNotFound("Fiche non trouvée");
    }
  }

  initMetas(){
    if(this.fiche?.Title) {
      this.seo.setTitles(this.fiche.Title);
    }
    if(this.fiche?.ShortDesc) {
      this.seo.setDescriptions(this.fiche?.ShortDesc);
    }
    if(this.fiche?.ImageUrl) {
      this.seo.setImages(this.fiche?.ImageUrl);
    }
    this.seo.setRobots('index','follow');
    this.seo.setCanonical(`${this.langService.current}/fiche/${this.fiche?.Slug}-${this.fiche?.ExternalId}`);
  }

  initCriterias(){
    this.surPlace = {handicap:[],parking:[],animals:[]};
    this.themes = [];
    this.classements = [];
    this.restaurants = [];
    this.labels = [];
    this.modesPaiement = [];
    this.services = [];
    this.equipements = [];
    this.activites = [];
    this.languesParlees = [];
    if(this.fiche?.FlatCriterias){
      for(let criteria of this.fiche.FlatCriterias){
        if(criteria.id.startsWith('sur-place')){
          if(criteria.id.startsWith('sur-place.tourisme-handicap')){
            //sur-place.tourisme-handicap.deficience-auditive
            //sur-place.tourisme-handicap.deficience-motrice
            //sur-place.tourisme-handicap.deficience-visuelle
            //sur-place.tourisme-handicap.deficience-mentale
            this.surPlace.handicap.push(criteria);
          }
          if(criteria.id.startsWith('sur-place.animaux-acceptes')){
            if(!this.surPlace.animals.find((criteria)=> criteria.id === 'sur-place.animaux-acceptes.animaux-acceptes-avec-supplement')){
              this.surPlace.animals.push(criteria);
            }
          }
          if(criteria.id.startsWith('sur-place.parking-voitures')){this.surPlace.parking.push(criteria);}
        }
        if(criteria.id.startsWith('theme')){
          this.themes.push(criteria);
        }
        if(criteria.id.startsWith('modes-de-paiement')){
          this.modesPaiement.push(criteria);
        }
        if(!this.isPro){
          if(criteria.id.startsWith('services') && !criteria.id.startsWith("services.langues-parlees")){
            this.services.push(criteria);
          }
          if(criteria.id.startsWith('equipements')){
            this.equipements.push(criteria);
          }
          if(criteria.id.startsWith('activites-sur-place')){
            this.activites.push(criteria);
          }
        } else if(this.pro) {
          this.equipements = this.pro.Equipements;
          this.activites = this.pro.Activites;
          this.services = this.pro.Services;
        }
        if(criteria.id.startsWith('services.langues-parlees')){
          this.languesParlees.push(criteria);
        }
        if(criteria.id.startsWith('labels-marques-et-sites-classes')){
          this.labels.push(criteria);
        }
        if(criteria.id.startsWith('localisation.situation.gare-sncf')){
          this.hasTrainStationNearly = true;
        }
      }
      for(let criteria of this.fiche.CriteriaTrees){
        if(criteria.id == 'classements' && criteria.Children && criteria.Children.length>0){
          this.classements = criteria.Children;
        }
        if(criteria.id == 'restaurants' && criteria.Children && criteria.Children.length>0){
          this.restaurants = criteria.Children;
        }
      }
      if(this.classements.length>0){
        this.classements = this.flatenizeCriteriaItems(this.classements)
      }
      if(this.restaurants.length>0){
        this.restaurants = this.flatenizeCriteriaItems(this.restaurants)
      }
    }
  }

  initFicheLiees(){
    if(this.ficheLieesRef){
      this.ficheLieesRef.reset();
    }
    if(this.fiche && this.fiche.FichesLiees && this.ficheLieesRef){
      const listItems = new SynapiListItems(this.fiche.FichesLiees);
      this.ficheLieesRef.updateListItems(listItems);

    }
  }

  initNavigation(){
    this.navigation = [];
    if(this.fiche){
      this.navigation.push({
        index:1,
        title: this.langService.current == 'fr' ? 'Présentation':'Presentation'
      });
      this.navigation.push({
        index:2,
        title: this.langService.current == 'fr' ? 'Sur Place': 'On site'
      });
      if(this.fiche.Ouverture || this.fiche.Tarifs){
        this.navigation.push({
          index:3,
          title: this.langService.current == 'fr' ? 'Horaires et Tarifs' : 'Opennings and Prices'
        });
      }
      if(this.fiche.FichesLiees){
        this.navigation.push({
          index:4,
          title: this.langService.current == 'fr' ? 'Découvrez aussi' : 'Discover also'
        });
      }
    }
  }

  setScrollAbout(){
    const scrollY = window.scrollY;
    const ficheContent = this.doc.getElementById("FicheContent");
    const pageNavigation = this.doc.getElementById("PageNavigation");
    const headerNav = this.doc.getElementById("HeaderNavbar");
    const spaceY = parseFloat(getComputedStyle(document.body).getPropertyValue('--spacing-spacing-2xl'))*parseFloat(getComputedStyle(document.documentElement).fontSize);
    if(ficheContent && pageNavigation && headerNav){
      const pageNavHeight = pageNavigation.clientHeight;
      const headerNavHeight = headerNav.clientHeight;
      const offsetHeader = pageNavHeight + headerNavHeight;
      const aboutHeight = this.aboutRef.nativeElement.clientHeight;
      const ficheContentClient = ficheContent.getBoundingClientRect();
      let offset = 0;
      if(ficheContentClient.top>(offsetHeader)){
        offset = 0;
      } else if(ficheContentClient.top + ficheContentClient.height - offsetHeader - aboutHeight - 2*spaceY <= 0 ){
        offset = ficheContentClient.height - aboutHeight - offsetHeader - 2*spaceY;
      }
      else{
        offset = Math.abs(ficheContentClient.top)+offsetHeader
      }
      this.aboutRef.nativeElement.style.top = offset+"px";
    }
  }

  initSchemaType(){
    if (!this.fiche?.TypeFiche){
      this.schemaType =  "TouristAttraction";
      return;
    }

    switch (this.fiche.TypeFiche) {
      case "FETE_ET_MANIFESTATION":
        this.schemaType =  "Event";
        return;
      case "PATRIMOINE_NATUREL":
      case "TERRITOIRE":
      case "PATRIMOINE_CULTUREL":
        this.schemaType = "TouristAttraction";
        return;
      case "RESTAURATION":
      case "DEGUSTATION":
        this.schemaType = "Restaurant";
        return;
      case "HOTELLERIE_PLEIN_AIR":
        this.schemaType = "Campground";
        return;
      case "HEBERGEMENT_COLLECTIF":
      case "HEBERGEMENT_LOCATIF":
      case "HOTELLERIE":
      case "SEJOUR_PACKAGE":
        this.schemaType = "LodgingBusiness";
        return;
      case "ACTIVITE":
      case "COMMERCE_ET_SERVICE":
        this.schemaType = "LocalBusiness";
        return;
      default:
        this.schemaType =  "TouristAttraction";
        return;
    }
  }

  onSncfClick(){
    const modal = this.modalService.create("FicheSncfModal",SynapiItemModalSncfComponent,this.vcr);
    modal.customClass = "nsm-centered synapi-item-modal-sncf";
    modal.setData({item:this.fiche},true);
    modal.open(true);
  }

  onFairguestClick(){
    const modal = this.modalService.create("FicheFairguestModal",SynapiItemModalFairguestComponent,this.vcr);
    modal.customClass = "nsm-centered synapi-item-modal-fairguest";
    modal.setData({item:this.fiche},true);
    modal.open(true);
  }

  onGalleryClick(index:number=1){
    const modal = this.modalService.create("FicheGalleryModal",SynapiItemGalleryComponent,this.vcr, {closable : false});
    modal.customClass = "nsm-dialog-animation-ltr nsm-centered synapi-item-modal-gallery";
    modal.setData({item:this.fiche,index:index,modal:modal},true);
    modal.open(true);
  }

  onPdfClick(){
    if(this.fiche?.ExternalId){
      this.wordpressService.getSynapiPdf(false,[this.fiche.ExternalId], true).then((url:any)=>{
        var w = window.open(url,'_blank');
        if(w){
          try {
            w.focus();
          } catch (e) {
            alert("Votre navigateur bloque actuellement l'ouverture de votre fichier à imprimer.");
          }
        }
      });
    }
  }

  onProClick(){
    if(this.fiche && this.pro){
      Object.entries(this.pro)
        .filter(([key, value]) => value)
        .forEach(([key, value]) => {
          { // @ts-ignore
            this.fiche[key] = value;
          }
        });
      this.isPro = true;
      this.initFiche(this.fiche);
    }

  }

  @HostListener('document:scroll', []) onWindowScroll() {
    this.setScrollAbout();
  }

  flatenizeCriteriaItems(
    criterias: SynapiCriteriaTreeItem[],
    parentName: string = '',
    depth: number = 0
  ): SynapiCriteriaTreeItem[] {
    let elements: SynapiCriteriaTreeItem[] = [];

    criterias.forEach((elem) => {
      elem.name  = depth > 0 ? (parentName !== '' ? parentName + ' > ' : '') + elem.name : elem.name;
      if (elem.Children?.length > 0) {
        elements = elements.concat(this.flatenizeCriteriaItems(elem.Children, elem.name, depth + 1));
      } else {
        elements.push(elem);
      }
    });

    elements.forEach((element) => {
      element.name = element.name.split(' > ').slice(-2).join(' > ');
    });
    return elements;
  }

  protected readonly SynapiItemTypes = SynapiItemTypes;
}
